<div #sectionContainer class="empty-container" [style.height.px]="section?.heightInPx"></div>
